"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Modal = require("./Modal");

var _Modal2 = _interopRequireDefault(_Modal);

var _VoucherUtil = require("../../utils/VoucherUtil");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PickupPlaceModal = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(PickupPlaceModal, _Component);

  function PickupPlaceModal() {
    (0, _classCallCheck3.default)(this, PickupPlaceModal);
    return (0, _possibleConstructorReturn3.default)(this, (PickupPlaceModal.__proto__ || (0, _getPrototypeOf2.default)(PickupPlaceModal)).apply(this, arguments));
  }

  (0, _createClass3.default)(PickupPlaceModal, [{
    key: "render",
    value: function render() {
      var place = this.props.place;

      return _react2.default.createElement(
        _Modal2.default,
        (0, _extends3.default)({ title: "Lipukkeen tiedot" }, this.props),
        _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(
            "div",
            { className: "row" },
            _react2.default.createElement(
              "div",
              { className: "col col-xs-12" },
              _react2.default.createElement(
                "h2",
                { className: "h3 mp-modal-title" },
                "Noutopaikka: ",
                place.name
              )
            ),
            _react2.default.createElement(
              "div",
              { className: "col col-xs-12" },
              _react2.default.createElement("div", { className: "hairline" })
            ),
            _react2.default.createElement(
              "div",
              { className: "col col-xs-12" },
              _react2.default.createElement(
                "div",
                { className: "row" },
                _react2.default.createElement(
                  "div",
                  { className: "col col-xs-12 col-sm-6" },
                  _react2.default.createElement(
                    "p",
                    null,
                    _react2.default.createElement(
                      "b",
                      null,
                      place.address,
                      ", ",
                      place.postal_code,
                      " ",
                      place.city
                    ),
                    _react2.default.createElement("br", null),
                    place.phone
                  ),
                  _react2.default.createElement(
                    "p",
                    null,
                    _react2.default.createElement(
                      "b",
                      null,
                      "Noudetaan seuraavia maa-aineksia:"
                    ),
                    _react2.default.createElement("br", null),
                    place.soil_types.map(function (type) {
                      return type.name;
                    }).join(", ")
                  ),
                  _react2.default.createElement(
                    "p",
                    null,
                    _react2.default.createElement(
                      "b",
                      null,
                      "Hinta / lipuke:"
                    ),
                    _react2.default.createElement("br", null),
                    (0, _VoucherUtil.priceWithoutVAT)(place),
                    " (alv 0 %)",
                    _react2.default.createElement("br", null),
                    (0, _VoucherUtil.priceWithVAT)(place),
                    " (alv 25.5%)"
                  )
                ),
                _react2.default.createElement(
                  "div",
                  { className: "col col-xs-12 col-sm-6" },
                  _react2.default.createElement(
                    "p",
                    null,
                    _react2.default.createElement(
                      "b",
                      null,
                      "Noutopaikan kuvaus:"
                    )
                  ),
                  _react2.default.createElement(
                    "p",
                    null,
                    place.description
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return PickupPlaceModal;
}(_react.Component), _class.propTypes = {
  isShowingModal: _react.PropTypes.bool.isRequired,
  handleClose: _react.PropTypes.func.isRequired,
  place: _react.PropTypes.object.isRequired
}, _temp);
exports.default = PickupPlaceModal;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/modal/PickupPlaceModal.js
 ** module id = 1163
 ** module chunks = 0
 **/